import { z } from "zod";

// max as const here for safety with regards to the error message.
const max = 999999;
const defaultValue = 100;
export const StartingCountsSchema = z
  .object({
    invoices: z.number().min(0, "No value below zero").max(max, `No value greater than ${max}`).default(defaultValue),
    events: z.number().min(0, "No value below zero").max(max, `No value greater than ${max}`).default(defaultValue),
    estimates: z.number().min(0, "No value below zero").max(max, `No value greater than ${max}`).default(defaultValue),
  })
  .default({ invoices: defaultValue, events: defaultValue, estimates: defaultValue })
  .describe("Defaults for pretty value");
